import React from 'react';
import cn from 'classnames';
import Title from '@/creditflowresearch/ui/common/components/Title';
import CheckUserAccess from '@/creditflowresearch/ui/common/components/CheckUserAccess';

import pageHeaderWrapper from './pageHeaderWrapper.module.scss';

interface IPageHeaderWrapperProps {
  title: string | React.ReactNode,
  userAccessChecks?: boolean[],
  className?: string,
  dataTest?: string,
  children?: React.ReactNode,
}

const PageHeaderWrapper = (
  {
   title = '',
   children,
   className,
   dataTest = 'pageHeaderTitle',
    userAccessChecks = [],
  } : IPageHeaderWrapperProps,
) => {
  const headerWrapper = (
    <div className={ cn(pageHeaderWrapper.pageHeader, className) }>
      <Title
        isH1
        className={ pageHeaderWrapper.pageHeaderTitle }
        dataTest={ dataTest }
      >
        { title }
      </Title>
      { children && (
        <div className={ pageHeaderWrapper.pageHeaderButtons }>
          { children }
        </div>
      ) }
    </div>
  );

  return (
    userAccessChecks.length > 0 ? (
      <CheckUserAccess
        conditions={ [{
          checks: userAccessChecks,
          fallback: (
            <div className={ pageHeaderWrapper.mobileNoAccess }>
              { headerWrapper }
            </div>
          ),
        }] }
      >
        { headerWrapper }
      </CheckUserAccess>
    ) : headerWrapper
  );
};

export default PageHeaderWrapper;
